import { Component, OnInit } from '@angular/core';
import * as $ from "jquery";
import { MedicinService } from '../services/index';
import { map } from "rxjs/operators";

@Component({
  selector: 'app-pets-accordian',
  templateUrl: './pets-accordian.component.html',
  styleUrls: ['./pets-accordian.component.scss']
})
export class PetsAccordianComponent implements OnInit {

  constructor(public ms: MedicinService) { }

  ngOnInit() {
  }

  public faqData: any = [
    {
      "Question": "How does the NuLifeSpan Rx prescription discount program work?",
      "Answer": "It's easy!<br/>1. Get Your Card: Sign up to get your free NuLifeSpan Rx Discount Card at www.nulifespanrx.com or use our free generic card.<br/>2. Compare Prices: Use our website to find the lowest prices on your prescription at pharmacies near you.<br/>3. Get Discounts: Show your card at the pharmacy to apply your discount and cashback instantly."
    },
    {
      "Question": "Is the NuLifeSpan Rx discount program really free?",
      "Answer": "Absolutely! The NuLifeSpan Rx prescription discount program is completely free to use. There are no hidden charges, such as membership fees or sign-up fees, and no eligibility requirements. Enjoy saving on your prescriptions without any cost."
    },
    {
      "Question": "How much cashback can I earn on my prescription purchases?",
      "Answer": "With every eligible transaction using your NuLifeSpan Rx discount card, you'll earn $1.50 cashback. Eligible transactions include any discounted prescription medication purchases made by you, your friends, or your family with the card. It's important to note that if the regular price of a prescription is lower than our discounted price and you choose not to use your NuLifeSpan Rx discount card, that purchase will not qualify for cashback."
    },
    {
      "Question": "How can I get my NuLifeSpan Rx discount card?",
      "Answer": "You can choose from two convenient options:<br/>1. Personalized Discount Card: Sign up at our website to receive your personalized NuLifeSpan Rx discount card. This option not only offers discounts but also allows you to earn cashback on eligible prescriptions. You can download, print, or add this card to your phone's wallet for easy access.<br/>2. Generic Card: If you prefer not to sign up, use our generic discount card available here. While you'll enjoy the same discounts on prescriptions, cashback rewards are exclusive to personalized cardholders. This card can also be downloaded, printed, or added to your phone's wallet.<br/>Both options provide significant savings on your prescriptions with NuLifeSpan Rx."
    },
    {
      "Question": "Do I have to show my card at the pharmacy every time?",
      "Answer": "Yes, to ensure you receive your discount, you must show your NuLifeSpan Rx card to the pharmacist with every purchase. You have the flexibility to download the card to your phone wallet, save it as a PDF, or even print it out."
    },
    {
      "Question": "Which pharmacy offers the cheapest price for my prescription?",
      "Answer": "You can use our pricing tool the find the nearest pharmacy that offers the cheapest price for your prescriptions."
    },
    {
      "Question": "Can I share my card with family and friends?",
      "Answer": "Absolutely, we encourage it! Feel free to print out copies of your NuLifeSpan Rx card or snap a picture to share with your friends and family. By spreading the word, you're helping your loved ones save on their prescriptions too. You'll also earn cashback on those purchases!"
    },
    {
      "Question": "How does NuLifeSpan Rx work on pet prescriptions?",
      "Answer": "We recognize that pets are important family members, too. That's why our NuLifeSpan Rx Discount Card can be used to save on prescriptions for your pets as well as for yourself. Just have your veterinarian write a prescription for your pet, and present it along with your discount card at a participating pharmacy to enjoy the savings."
    }
  ]
  public collapse: any;
 
  GetFaq() {
    this.ms.GetFaq().pipe(map(res => res.json()))
      .subscribe(data => {
        if (data.length > 0) {
          console.log(data)
          this.faqData = JSON.parse(data);
        }
        else {
          //error
        }
      });
  }
  toggleCollapse(val) {
    $('.panel-collapse').removeClass('show');
    let idSet = '#' + val;
    let collapseSet = '#collapse' + val;
    let expandedValue = $(idSet).attr('aria-expanded');
    if (expandedValue == 'true') {
      $(idSet).attr('aria-expanded', 'false');
      $(collapseSet).removeClass('show');
    } else {
      $(".removeAttr").attr('aria-expanded', 'false');
      $(idSet).attr('aria-expanded', 'true');
      $(collapseSet).addClass('show');
    }
  }
}